import ManagerCertificatesView from '@/requests/certificates/employmentCertificate/views/manager/viewManager'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/requests/viewCertifiesRequests/viewManager')({
  beforeLoad: ({ context }) => {
    if (!context.user) {
      throw redirect({ to: '/login' });
    }

    const { isAdmin } = context.userRoles;

    if (!isAdmin) {
      throw redirect({ to: '/unauthorized' });
    }
  },
  component: ManagerCertificatesView,
})